import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { modalDecorator } from 'helpers/decorators'
import styles from './body.styl'

const resetStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)'
  },
  content: {
    position: 'absolute',
    top: '40px',
    left: '5px',
    right: '5px',
    bottom: '40px',
    border: 'none',
    background: 'transparent',
    overflow: 'visible',
    WebkitOverflowScrolling: 'touch',
    borderRadius: 0,
    outline: 'none',
    padding: '20px'
  }
}

@modalDecorator({ resetStyles })
class MaterialModalBody extends Component {
  static propTypes = {
    title: PropTypes.any,
    children: PropTypes.any,
    noHeader: PropTypes.bool,
    narrow: PropTypes.bool,
    wide: PropTypes.bool,
    wider: PropTypes.bool,
    large: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    colorClass: PropTypes.string,
    titleKey: PropTypes.string,
    noClose: PropTypes.bool
  }

  static defaultProps = {
    noHeader: false,
    narrow: false,
    wide: false,
    wider: false,
    large: false
  }

  handleClose = () => {
    this.props.onClose()
  }

  renderTitle = () => {
    const { titleKey, title } = this.props

    if (titleKey) {
      return (
        <FormattedMessage
          id={titleKey}
          defaultMessage={typeof title === 'string' ? title : ''}
        />
      )
    }
    return title
  }

  render() {
    const { colorClass, narrow, wide, wider, large, noHeader, noClose } = this.props

    const wideClass = wide ? styles.wide : ''
    const widerClass = wider ? styles.wider : ''
    const largeClass = large ? styles.large : ''

    const headerClasses = [styles.header, styles[colorClass]]
    const wrapClasses = [styles.wrap, wideClass, widerClass, largeClass]

    narrow && wrapClasses.push(styles.narrow)

    return (
      <div className={wrapClasses.join(' ')}>
        {!noHeader &&
          <div className={headerClasses.join(' ')}>
            <h2 className={styles.title}>
              {this.renderTitle()}
            </h2>
            <i
              className={`ico ico--close ${styles.close}`}
              onClick={this.handleClose}
            />
          </div>}
        {noHeader &&
          !noClose &&
          <i
            className={`ico ico--close ${styles.close} ${styles.grey}`}
            onClick={this.handleClose}
          />}
        {this.props.children}
      </div>
    )
  }
}

export default MaterialModalBody
